const openQuartierLocationList = [
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "ain-sebaa",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "maarif",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "beausejour",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "oulfa",
    },
    {
        slug: "casablanca",
        type: "location-bureaux",
        quartier: "bourgogne-ouest",
    },
    {
        slug: "casablanca",
        type: "location-bureaux",
        quartier: "palmier",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "bourgogne",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "californie",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "marina",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "hay-chrifa",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "palmier",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "racine",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "bourgogne-est",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "tamaris",
    },
    {
        slug: "casablanca",
        type: "location-bureaux",
        quartier: "sidi-maarouf",
    },
    {
        slug: "casablanca",
        type: "location-studios",
        quartier: "pas-cher",
    },
    {
        slug: "rabat",
        type: "location-studios",
        quartier: "l-ocean",
    },
    {
        slug: "rabat",
        type: "location-studios",
        quartier: "hassan",
    },
    {
        slug: "bouskoura",
        type: "location-appartements",
        quartier: "bouskoura-ville",
    },
    {
        slug: "bouskoura",
        type: "location-appartements",
        quartier: "green-town-bouskoura",
    },
    {
        slug: "bouskoura",
        type: "location-villas",
        quartier: "green-town-bouskoura",
    },
    {
        slug: "bouskoura",
        type: "location-villas",
        quartier: "dar-bouazza",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "sidi-maarouf",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "bourgogne-ouest",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "finance-city",
    },
    {
        slug: "casablanca",
        type: "location-studios",
        quartier: "bourgogne-ouest",
    },
    {
        slug: "marrakech",
        type: "location-studios",
        quartier: "gueliz",
    },

    {
        slug: "casablanca",
        type: "location-bureaux",
        quartier: "bourgogne-est",
    },
    {
        slug: "casablanca",
        type: "location-studios",
        quartier: "finance-city",
    },
    {
        slug: "casablanca",
        type: "location-studios",
        quartier: "gauthier",
    },
    {
        slug: "casablanca",
        type: "location-studios",
        quartier: "moulay-youssef",
    },
    {
        slug: "casablanca",
        type: "location-studios",
        quartier: "palmier",
    },
    {
        slug: "casablanca",
        type: "location-villas",
        quartier: "sidi-maarouf",
    },
    {
        slug: "casablanca",
        type: "location-villas",
        quartier: "tamaris",
    },
    {
        slug: "casablanca",
        type: "location-villas",
        quartier: "anfa",
    },
    {
        slug: "casablanca",
        type: "location-villas",
        quartier: "californie",
    },
    {
        slug: "casablanca",
        type: "location-villas",
        quartier: "ain-diab",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "pas-cher",
    },

    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "2000-dh",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "3000-dh",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "5000-dh",
    },
    {
        slug: "casablanca",
        type: "location-appartements",
        quartier: "haut-standing",
    },
    {
        slug: "rabat",
        type: "location-appartements",
        quartier: "riyad",
    },
    {
        slug: "rabat",
        type: "location-appartements",
        quartier: "l-ocean",
    },
    {
        slug: "rabat",
        type: "location-appartements",
        quartier: "hassan-centre-ville",
    },
    {
        slug: "rabat",
        type: "location-appartements",
        quartier: "agdal",
    },
    {
        slug: "marrakech",
        type: "location-appartements",
        quartier: "ennakhil-palmeraie",
    },
    {
        slug: "kenitra",
        type: "location-appartements",
        quartier: "maamora",
    },
    {
        slug: "kenitra",
        type: "location-appartements",
        quartier: "mimosa",
    },
    {
        slug: "kenitra",
        type: "location-appartements",
        quartier: "ville-haute",
    },
    {
        slug: "kenitra",
        type: "location-appartements",
        quartier: "moutanabi",
    }
];
export default openQuartierLocationList